import { render, staticRenderFns } from "./SimplePagination.vue?vue&type=template&id=1051ce31&scoped=true&"
import script from "./SimplePagination.vue?vue&type=script&lang=ts&"
export * from "./SimplePagination.vue?vue&type=script&lang=ts&"
import style0 from "./SimplePagination.vue?vue&type=style&index=0&id=1051ce31&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051ce31",
  null
  
)

export default component.exports